var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPc = function SvgIconPc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060E41",
    d: "M20.028 0H3.972C3.104 0 2.4.652 2.4 1.456v11.877h19.2V1.456C21.6.652 20.896 0 20.028 0M19.2 10H4.8V2.222h14.4zm4.62 8.3c-.216-.311-2.22-3.856-2.22-3.856H2.4S.432 17.967.216 18.256c-.14.185-.215.406-.216.633C0 19.503.537 20 1.2 20h21.6c.663 0 1.2-.497 1.2-1.111a1.13 1.13 0 0 0-.18-.589M15 17.778H9c-.331 0-.6-.249-.6-.556s.269-.555.6-.555h6c.331 0 .6.248.6.555s-.269.556-.6.556"
  })));
};
export default SvgIconPc;